import styled from 'styled-components';

export default styled.span`
    padding: 15px 50px;
    border-radius: 70px;
    &::-moz-focus-inner {
        border: 0;
      }
    &:focus {
        outline: none;
    }
`;
